export const withinLast7Days = dt => {
  const date = new Date(dt)
  const now = new Date()
  const last7DaysDate = new Date()
  last7DaysDate.setDate(now.getDate() - 7)

  return date >= last7DaysDate && date <= now
}
